import { v4 as uuidv4 } from 'uuid';

import operatorDefs from '../defaults/operatorsDefinitions';
import FieldNames from '../../../defaults/FieldNames.json';

export function getDefaultFilterValue(field, customCodedValues) {
  if(field?.domain === "custom" && customCodedValues?.length) {
    return customCodedValues[0];
  } else if (field?.domain?.codedValues?.length) {
    return field?.domain?.codedValues[0]?.name ? field.domain.codedValues[0].name : field.domain.codedValues[0];
  }

  return '';
}
export function getShortStringOperators()
{
  const operators = operatorDefs['limitedString'];

  return operators || [];
}

export function getValidOperators(field, fieldType) {
  if(!field || !fieldType)
  {
    return [];
  }

  let operators = operatorDefs[getGenericFieldType(fieldType)];

  if(field.modelName === FieldNames.featureFields.fundingDepartment || field.modelName === FieldNames.featureFields.fundingAgency || 
    field.modelName === FieldNames.featureFields.fundingRegion || field.modelName === FieldNames.featureFields.fundingUnit || 
    field.modelName === FieldNames.featureFields.fundingTribe || field.modelName === FieldNames.featureFields.fundingSubUnit || 
    field.modelName === FieldNames.featureFields.fundingUnitType || field.modelName === FieldNames.featureFields.fundingSource || 
    field.modelName === FieldNames.featureFields.fundingSourceProgram || field.modelName === FieldNames.featureFields.fundingSourceCategory || 
    field.modelName === FieldNames.featureFields.fundingSourceSubCategory)
  {
    operators = operators.filter(op => op.alias !== 'starts with' && op.alias !== 'ends with');
  } else if(field.modelName === FieldNames.featureFields.category || field.modelName === FieldNames.featureFields.class || 
    field.modelName === FieldNames.featureFields.completionFiscalQuarter || field.modelName === FieldNames.featureFields.estimatedSuccessProbability || 
    field.modelName === FieldNames.featureFields.feasibility || field.modelName === FieldNames.featureFields.initiationFiscalQuarter || 
    field.modelName === FieldNames.featureFields.isApproved || field.modelName === FieldNames.featureFields.isFunded || 
    field.modelName === FieldNames.featureFields.isWUI || field.modelName === FieldNames.featureFields.isRTRL ||  
    field.modelName === FieldNames.featureFields.isCarryover || field.modelName === FieldNames.featureFields.isSagebrush ||
    field.modelName === FieldNames.featureFields.priority || field.modelName === FieldNames.featureFields.status || 
    field.modelName === FieldNames.featureFields.treatmentDriver || field.modelName === FieldNames.featureFields.type || 
    field.modelName === FieldNames.featureFields.initiationFiscalQuarter || field.modelName === FieldNames.featureFields.state ||
    field.modelName === FieldNames.featureFields.isSubstitute){
      operators = operators.filter(op => op.alias !== 'starts with' && op.alias !== 'ends with' && op.alias !== 'contains' && op.alias !== 'does not contain');
  }

  operators = operators.filter(op => op.alias !== "nonop"); // Not a selectable option

  return operators || [];
}

export function getStringExclusionOperator() {
  const operators = operatorDefs['string'];
  const filteredOperators = operators.filter(o => o.alias === 'is not');
  return filteredOperators || [];
}

export function getStringEquivalenceOperator() {
  const operators = operatorDefs['string'];
  const filteredOperators = operators.filter(o => o.alias === 'is');
  return filteredOperators || [];
}

export function getEmptyOperator() {
  const operators = operatorDefs['string'];
  const filteredOperators = operators.filter(o => o.alias === 'nonop');
  return filteredOperators || [];
}

export function getGenericFieldType(fieldType) {
  // REST API Field Types
  // strings: 'esriFieldTypeString',
  // dates: 'esriFieldTypeDate',
  // numbers: ['esriFieldTypeOID',
  //           'esriFieldTypeSmallInteger',
  //           'esriFieldTypeInteger',
  //           'esriFieldTypeSingle',
  //           'esriFieldTypeDouble'],

  // JSAPI Field Types
  //small-integer | integer | single | double | long | string | date | oid | geometry | blob | raster | guid | global-id | xml

  switch (fieldType) {
    case null:
      return null;
    case undefined: 
      return null;
    case 'esriFieldTypeString':
    case 'esriFieldTypeGUID':
    case 'oid':
    case 'guid':
    case 'global-id':
    case 'string':
      return 'string';

    case 'esriFieldTypeOID':
    case 'esriFieldTypeSmallInteger':
    case 'esriFieldTypeInteger':
    case 'esriFieldTypeSingle':
    case 'esriFieldTypeDouble':
    case 'small-integer':
    case 'integer':
    case 'single':
    case 'double':
    case 'long':
      return 'number';

    case 'esriFieldTypeDate':
    case 'date':
      return 'date';

    case 'epoch':
      return 'epoch';

    default:
      console.warn('Invalid field type! Defaulting to string.', fieldType);
      return 'string';
  }
}

export function generateId() {
  return uuidv4();
}
